import { ActionTree, GetterTree, MutationTree } from 'vuex';
import {
  EventType,
  AccountItemResultInterface,
  BuildingItemInterface,
  CounterItemResultInterface,
  PaginationInterface
} from '@/modules/backend';

export type NotificationType = EventType;

export interface NotificationInterface {
  Id: string | number;
  Type: NotificationType;
  IsRead: boolean;
  Building: BuildingItemInterface;
  Account: AccountItemResultInterface;
  Counter: CounterItemResultInterface;
  CreatedAt: Date;
}

interface State {
  IsLoaded: boolean;
  Notifications: NotificationInterface[];
  Pagination: PaginationInterface;
}

export const state: State = {
  IsLoaded: false,
  Notifications: [],
  Pagination: {
    Pagination: {
      PerPage: 10,
      Page: 1,
      CountPages: 1,
      Count: 0
    }
  }

};

const MAX_ITEMS = 5;

export const getters: GetterTree<State, unknown> = {
  Notifications: (store) => store.Notifications,

  UnreadNotifications: (store) => {
    const items = store.Notifications.filter((notification) => !notification.IsRead);

    if (items.length === 0) {
      return [];
    }

    return items.slice(Math.max(items.length - MAX_ITEMS, 0));
  },

  Count: (store) => store.Notifications.length,

  Pagination: (store) => store.Pagination
};

export const mutations: MutationTree<State> = {
  Notifications: (store, payload: NotificationInterface[]) => (store.Notifications = payload),

  MarkAsRead: (store, item: NotificationInterface) => {
    store.Notifications = store.Notifications.map((notification) => {
      if (notification.Id === item.Id) {
        notification.IsRead = true;
      }
      return notification;
    });
  },

  Pagination: (store, payload: PaginationInterface) => {
    store.Pagination = payload;
  },

  Push: (store, payload: NotificationInterface) => (store.Notifications = [...store.Notifications, {
    ...payload,
    Id: store.Notifications.length
  }])
};

export const actions: ActionTree<State, unknown> = {
  /* eslint-disable @typescript-eslint/no-empty-function */
  Fetch: async () => {

  },
  Push: async () => {

  },
  MarkAsRead: async () => {

  }
  /* eslint-enable @typescript-eslint/no-empty-function */
};

export const notifications = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
